{
	"cardHeader": "Získejte přístup ke svým prohlášením",
	"supplierTitle": "Jste dodavatelem prohlášení evoZero?",
	"supplierDescription": "Spravujte prohlášení pro své materiály evoZero.",
	"loginButton": "Přihlášení"
}
